import { render, staticRenderFns } from "./AverageProjectHealthChart.vue?vue&type=template&id=1c453d45"
import script from "./AverageProjectHealthChart.vue?vue&type=script&lang=js"
export * from "./AverageProjectHealthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports